<div class="card">
  <div class="grid">
    <div class="col-12">
      <app-emed-header></app-emed-header>
    </div>
    <h3 class="p-messages p-messages-success">{{ HeaderBarText }}</h3>
  </div>

  <div class="card">
    <form [formGroup]="CellVerification2F" (ngSubmit)="VerifyCellno()">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12" *ngIf="cellVerfButton == true">
          <span class="p-float-label">
            <input
              id="float-input"
              type="text"
              appFormErrorMessages
              pInputText
              formControlName="cellNo"
              autocomplete="off"
            />
            <label for="float-input">
              <span class="required-asteric"> * </span>Enter Cell No:</label
            >
          </span>
        </div>
        <div class="field col-12 md:col-12" *ngIf="OtpVerfButton == true">
          <p-password
            id="float-input"
            appFormErrorMessages
            formControlName="Otp"
            autocomplete="off"
            [toggleMask]="true"
            [feedback]="false"
          ></p-password>
          <label for="float-input">
            <span class="required-asteric"> * </span>Enter Security
            Token:</label
          >
        </div>

        <div class="field col-12 md:col-2">
          <button
            pButton
            type="submit"
            icon="pi pi-check"
            *ngIf="cellVerfButton == true"
            label="Send verification code"
            class="p-button-plain"
          ></button>
        </div>
      </div>
    </form>
    <div class="field col-12 md:col-2">
      <button
        pButton
        type="button"
        *ngIf="OtpVerfButton == true"
        icon="pi pi-check"
        label="Verify Security code"
        class="p-button-plain"
        (click)="VeifyToken()"
      ></button>
    </div>
    <div class="field col-12 md:col-2">
      <button
        pButton
        type="submit"
        icon="pi pi-check"
        *ngIf="cellOkButton == true"
        label="Ok"
        class="p-button-plain"
        (click)="logOut()"
      ></button>
    </div>
    <div
      class="col-12 p-messages p-messages-summary border-radius-5"
      *ngIf="ShowErrorSummary"
    >
      <span style="font-size: 14px">{{ errorValidationSummary }}</span>
    </div>
  </div>
</div>
